module.exports = __webpack_public_path__ + "static/media/lineChart4.42d32138.svg";